export default __webpack_public_path__ + "static/media/Padron_1964AClosed.59885ab3.jpg";